export default "__VITE_ASSET__U20YrR7P__"